import React from 'react'

const Dashboard8 = () => {
  return (
    <h1>Dashboard8</h1>
  )
}

export default Dashboard8